import { createSelector } from 'reselect';

const getAllNotifications = state => state.app.notifications.list;

export const getUnreadNotifications = createSelector(
  [getAllNotifications],
  (notifications) => !notifications ? [] : notifications.filter(({readAt}) => readAt === null)
);